import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="m27.895 8.553-2-4A1 1 0 0 0 25 4H7a1 1 0 0 0-.895.553l-2 4A1 1 0 0 0 4 9v17a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V9a1 1 0 0 0-.105-.447M7.618 6h16.765l1 2H6.618zM26 26H6V10h20zm-5.292-7.707a1 1 0 0 1 0 1.415l-4 4a1 1 0 0 1-1.415 0l-4-4a1 1 0 1 1 1.415-1.415L15 20.586V13a1 1 0 0 1 2 0v7.586l2.293-2.293a1 1 0 0 1 1.415 0"
    />
  </svg>
);
const SvgIconTemplate = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconTemplate);
export default Memo;
